import {STRATEGIC_PARTNER} from "../constants/strategicPartners";
import renaissanceConfig from "../constants/renaissanceConfig";

export const renaissanceLouisianaStrings = {
    en: {
        maritalStatus: "Are you married or have a Partner?",
        partnerClarification: "Partner includes domestic partnerships and civil unions.",
        coverSpouse: "My spouse or partner and me",
    },
    es: {
        maritalStatus: "¿Está casado(a) o tiene una pareja?",
        partnerClarification: "Pareja incluye parejas de hecho y uniones civiles.",
        coverSpouse: "Mi cónyuge o pareja y yo",
    },
};

export function isLouisiana(state) {
    return ["LA", "Louisiana"].includes(state)
}

export function getEnrollmentState(initialData) {
    return initialData?.contractInfo?.issueState || initialData?.employer?.address?.state
}

export function isRenaissanceLouisiana(initialData) {
    return STRATEGIC_PARTNER.NAME === renaissanceConfig.NAME && isLouisiana(getEnrollmentState(initialData))
}
